import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule } from '../icon/icon.module';
import { SaveStatusComponent } from './save-status.component';

@NgModule({
  imports: [CommonModule, IconModule],
  declarations: [SaveStatusComponent],
  exports: [SaveStatusComponent],
})
export class SaveStatusModule {}
